var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.773,
    height: 17.691,
    viewBox: "0 0 21.773 17.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "translate(0 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M21.773,50.094a9.307,9.307,0,0,1-2.572.7,4.439,4.439,0,0,0,1.964-2.467,8.921,8.921,0,0,1-2.831,1.081,4.463,4.463,0,0,0-7.721,3.052,4.6,4.6,0,0,0,.1,1.018,12.635,12.635,0,0,1-9.2-4.669A4.465,4.465,0,0,0,2.888,54.78a4.408,4.408,0,0,1-2.017-.55v.049a4.484,4.484,0,0,0,3.576,4.386,4.455,4.455,0,0,1-1.17.147,3.946,3.946,0,0,1-.845-.076A4.506,4.506,0,0,0,6.6,61.845a8.969,8.969,0,0,1-5.535,1.9A8.361,8.361,0,0,1,0,63.688a12.567,12.567,0,0,0,6.848,2,12.617,12.617,0,0,0,12.7-12.7c0-.2-.007-.388-.016-.577A8.9,8.9,0,0,0,21.773,50.094Z",
    transform: "translate(0 -48)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f74ed4a1d70d22933353d2575ea13a14.svg";
export { ForwardRef as ReactComponent };